export default __webpack_public_path__ + "static/media/06.6c565e2d.jpg";